import React from 'react'

/**
 * A labelled group of fields. Replaces the bare `separator my-4` divider: the
 * hairline is the same, but the reader is told what the group controls.
 *
 * The first section in a body drops its rule automatically (CSS `:first-child`),
 * so sections can be added or removed without leaving a stray line at the top.
 *
 * `aside` puts a badge or a small action next to the heading.
 */
const ModalSection = ({ title, hint, aside, children, className = '' }) => (
  <section className={`app-modal__section ${className}`.trim()}>
    {(title || aside) && (
      <div className='app-modal__section-head'>
        {title && <h5 className='app-modal__section-title'>{title}</h5>}
        {aside}
      </div>
    )}
    {hint && <p className='app-modal__section-hint'>{hint}</p>}
    {children}
  </section>
)

export default ModalSection
